import React from 'react';

const ProductSection = () => {
  return (
    <>
      {/* Product Section start */}
      <div id="producto" className="about-area pd-top-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center mb-5">
                <h6 className="sub-title">NUESTRO PRODUCTO</h6>
                <h2 className="title">
                  ¿Qué es <span>FirmasCheck</span>?
                </h2>
                <p className="content">
                  FirmasCheck es una plataforma web para gestionar firmas de documentos con capas extra de validación de identidad. 
                  Sube tu documento, define quiénes deben firmar y dónde, enviamos los enlaces por correo, validamos al firmante y 
                  te notificamos cada avance hasta la firma final.
                </p>
              </div>
            </div>
          </div>
          
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="single-about-inner product-benefit-card benefit-time mb-4">
                <div className="thumb mb-3">
                  <div className="icon-wrapper">
                    <i className="fas fa-clock"></i>
                  </div>
                </div>
                <div className="details">
                  <h5>Ahorra tiempo</h5>
                  <p>
                    Evita impresiones, scans y traslados. Todo el proceso se realiza de forma digital y remota.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="single-about-inner product-benefit-card benefit-accuracy mb-4">
                <div className="thumb mb-3">
                  <div className="icon-wrapper">
                    <i className="fas fa-check-circle"></i>
                  </div>
                </div>
                <div className="details">
                  <h5>Menos errores</h5>
                  <p>
                    Define firmas y campos exactos antes de enviar. No más documentos mal completados.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="single-about-inner product-benefit-card benefit-traceability mb-4">
                <div className="thumb mb-3">
                  <div className="icon-wrapper">
                    <i className="fas fa-search"></i>
                  </div>
                </div>
                <div className="details">
                  <h5>Trazabilidad total</h5>
                  <p>
                    Registro de cada evento y confirmaciones por correo. Sabes exactamente qué pasa y cuándo.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="single-about-inner product-benefit-card benefit-experience mb-4">
                <div className="thumb mb-3">
                  <div className="icon-wrapper">
                    <i className="fas fa-mobile-alt"></i>
                  </div>
                </div>
                <div className="details">
                  <h5>Mejor experiencia</h5>
                  <p>
                    Firma desde cualquier dispositivo, sin instalar nada. Simple y accesible para todos.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Product Section end */}
    </>
  );
};

export default ProductSection;
